import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const CodeBlock = makeShortcode("CodeBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "contentcardcustomizing"
    }}>{`ContentCardCustomizing`}</h1>
    <p>{`Protocol defining methodology for customizing content cards based on the template type.`}</p>
    <h2 {...{
      "id": "protocol-definition"
    }}>{`Protocol Definition`}</h2>
    <CodeBlock slots="heading, code" repeat="1" languages="Swift" mdxType="CodeBlock" />
    <h4 {...{
      "id": "swift"
    }}>{`Swift`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`protocol ContentCardCustomizing {
    func customize(template: SmallImageTemplate)
}
`}</code></pre>
    <h2 {...{
      "id": "methods"
    }}>{`Methods`}</h2>
    <h3 {...{
      "id": "customize"
    }}>{`customize`}</h3>
    <p>{`Customize content cards with `}<a parentName="p" {...{
        "href": "../PublicClasses/Template/smallimage-template.md"
      }}>{`SmallImageTemplate`}</a>{`.`}</p>
    <h4 {...{
      "id": "parameters"
    }}>{`Parameters`}</h4>
    <ul>
      <li parentName="ul"><em parentName="li">{`template`}</em>{` - The `}<inlineCode parentName="li">{`SmallImageTemplate`}</inlineCode>{` instance to be customized.`}</li>
    </ul>
    <h4 {...{
      "id": "syntax"
    }}>{`Syntax`}</h4>
    <CodeBlock slots="heading, code" repeat="1" languages="Swift" mdxType="CodeBlock" />
    <h4 {...{
      "id": "swift-1"
    }}>{`Swift`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`func customize(template: SmallImageTemplate)
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      